export class AccountInfo {
  accountNumber: string;
  corporationCode: string;
  isAutoAssign: boolean;
  isAutoPPSA: boolean;
  isLocatorEnabled: boolean;
  isLVSEnabled: boolean;
  monitoringEndDate: string;
  monitoringStartDate: string;
  newAccountNumber: string;
  oldAccountNumbers: string[];
  repoAssignmentDate: Date;
  repoContractNumber: string;
  repoInstruction: string;
  vin: string;
}

export class AccountViewModel {
  accountInfo: AccountInfo;
  canadianMoveInfo: CanadianMoveInfo;
  dailyMonitoringInfo: DailyMonitoringInfo;
  debtorDetails: DebtorInfo[];
  history: HistoryInfo;
  insuranceDetail: InsuranceDetail;
  lvsDebtorInfos: LVSDebtorInfo[]
  ppsaDetails: PPSAInfo[];
  queueActions: QueueActionsModel[];
  //queueHistoryDetails: QueueHistoryInfo[];
  registrationInfo: RegistrationInfo;
  usMoveInfo: USMoveInfo;
}

export class CanadianMoveInfo {
  latestReading: string;
  mvrDetails: MVRInfo[];
  mvrMove: boolean;
  odometerDetails: OdometerInfo[];
  readingMove: boolean;
  adjacency: boolean;
}

export class CustomBorderProtection {
  date: Date;
  eventAging: number;
}

export class DailyMonitoringInfo {
  cbp: boolean;
  cbpDetails: CustomBorderProtection[];
  ebay: boolean;
  ebayDetails: Ebay[];
  impound: boolean;
  impoundDetails: Impound[];
  lienSale: boolean;
  lienSaleDetails: LienSale[];
  salvage: boolean;
  salvageDetails: Salvage[];
  seizure: boolean;
  seizureDetails: Seizure[];
  stolen: boolean;
  stolenDetails: Stolen[];
}

export class DebtorAddressInfo {
  city: string;
  postalZipCode: string;
  provinceState: string;
  street: string;
}

export class DebtorInfo {
  address: DebtorAddressInfo;
  coaCurrent: boolean;
  dob: Date;
  lvsDebtor: boolean;
  name: string;
  ncoa: boolean;
  newAddress: DebtorAddressInfo;
  newAddressReportedIn: Date;
  nixie: boolean;
  nixieReportedIn: Date;
  pcoa: boolean;
  province: boolean;
  provinceReportedIn: Date;
}

export class Ebay {
  date: Date;
  eventAging: number;
  itemNumber: string;
}

export class History {
  accountUpdate?: string;
  comment: string;
  customerFollowUp?: string;
  damagePost?: boolean;
  date: Date;
  debtorProvinceFlag?: boolean;
  ebay?: boolean;
  eventDate?: Date;
  exportFlag?: boolean;
  impound?: boolean;
  insuranceFollowUp?: string;
  insurancePost?: boolean;
  investigation?: string;
  jurisdiction?: string;
  mvrFlag?: boolean;
  nameFlag?: boolean;
  ncoaFlag?: boolean;
  nixieFlag?: boolean;
  odometerReadingFlag?: boolean;
  other?: boolean;
  pcoaFlag?: boolean;
  ppsaAmendmentStatus?: string;
  ppsaRegistrationStatus?: string;
  reportDate?: Date;
  salvage?: boolean;
  status: string;
  stolen?: boolean;
  updatedInfoFlag: boolean;
  usMVRFlag?: boolean;
  usReadingFlag?: boolean;
  user: string;
}

export class HistoryInfo {
  confirmedMove: History[];
  dailyMonitoring: History[];
  lvsTrigger: History[];
  potentialMove: History[];
  usMove: History[];
  vehiclePost: History[];
}

export class Impound {
  date: Date;
  eventAging: number;
  licensePlate: string;
  licenseProvinceState: string;
  location: string;
  note: string;
  phone: string;
  phoneProvinceState: string;
  reason: string;
  reference: string;
  status: string;
}

export class InsuranceDetail {
  insuranceInfos: InsuranceInfo[];
  preInsuranceInfos: InsuranceInfo[];
}

export class InsuranceInfo {
  date: Date;
  eventAging: number;
  eventType: string;
  reportedIn: Date;
}

export class LienSale {
  date: Date;
  eventAging: number;
  note: string;
}

export class LVSDebtor {
  contractDebtorId?: number;
  firstName?: string;
  firstNameChanged: boolean;
  foundInCG: boolean;
  lastName?: string;
  lastNameChanged: boolean;
  middleName: string;
  middleNameChanged: boolean;
  newFirstName: string;
  newLastName: string;
  newMiddleName: string;
}

export class LVSDebtorInfo {
  lienStatus: string;
  lvsVins: string;
  jurisdiction: string;
  lvsDebtors: LVSDebtor[];
}

export class MVRInfo {
  mvrDate: Date;
  provinceState: string;
  reportedIn: Date;
}

export class OdometerInfo {
  city: string;
  odometerDate: Date;
  provinceState: string;
  reportedIn: Date;
}

export class PPSAInfo {
  dischargeDate: Date;
  jurisdiction: string;
  registrationDate: Date;
}

export class QueueActionsModel {
  account?: WorkQueueUserOption;
  comments: string;
  customer?: WorkQueueUserOption;
  displayOrder: number;
  id: number;
  insurance?: WorkQueueUserOption;
  investigation?: WorkQueueUserOption;
  //showAccount?: boolean;
  //showCustomer?: boolean;
  //showInsurance?: boolean;
  //showInvestigation?: boolean;
  workQueueStatus: WorkQueueStatus;
  workQueueTitle: string;
  workQueueType: WorkQueueType;
}

export class RegistrationInfo {
  amountFinanced: number;
  make: string;
  model: string;
  termInYears: number;
  year: string;
}

export class Salvage {
  date: Date;
  eventAging: number;
  location: string;
  mileage: string;
  note: string;
  purchasedFrom: string;
  stockNumber: string;
}

export class Seizure {
  caseNumber: string;
  date: Date;
  eventAging: number;
  location: string;
  note: string;
  organization: string;
  seizedFrom: string;
  seizureDate: Date;
  value: string;
}

export class Stolen {
  date: Date;
  eventAging: number;
  licensePlate: string;
  licenseProvinceState: string;
  location: string;
  phone: string;
  phoneProvinceState: string;
  reference: string;
  status: string;
}

export class USMoveInfo {
  exportDate: Date;
  exportFlag: boolean;
  exportReportedIn: Date;
  latestReading: string;
  mvrDetails: MVRInfo[];
  mvrMove: boolean;
  odometerDetails: OdometerInfo[];
  readingMove: boolean;
  adjacency: boolean;
  riskStatus: string;
  riskStatusReportedIn: Date;
}

export enum SiblingComponentName {
  workqueue = 'WorkQueueComponent',
  cm = 'LenderRemediationQueueComponent',
  pm = 'LenderReconciliationQueueComponent',
  us = 'UsQueueComponent',
  vp = 'VehiclePostQueueComponent',
  dns = 'DailyMonitoringComponent',
  lvs = 'LvsTriggerComponent',
  lookup = 'LookupPageComponent'
}

export enum QueueName {
  cm = 1,
  pm = 2,
  us = 3,
  vp = 4,
  dns = 5,
  lvs = 6,
}

export enum WorkQueuePPSARegistrationOption {
  Registered = 'Registered',
  Declined = 'Declined',
  Assign = 'Assign'
}

export enum WorkQueueStatus {
  New = 'New',
  UnderReview = 'Under Review',
  Complete = 'Complete',
}

export enum WorkQueueType {
  LenderReconciliation = 'LenderReconciliation',
  LenderRemediation = 'LenderRemediation',
  WatchList = 'WatchList',
}

export enum WorkQueueUserOption {
  Completed = 'Completed',
  NotRequired = 'Not Required',
  Assign = 'Assign',
}
